import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTagEmpty = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_5875_132952)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.87568 3.91115L9.87636 3.91212L12.2203 7.21615L9.87636 10.5202L9.87568 10.5211C9.75721 10.689 9.55809 10.7994 9.33369 10.7995C9.33357 10.7995 9.33345 10.7995 9.33333 10.7995L2.91712 10.7936H2.91667C2.54787 10.7936 2.25 10.4951 2.25 10.1328V4.29948C2.25 3.93721 2.54787 3.63865 2.91667 3.63865L2.91712 3.63865L9.33333 3.63281C9.3334 3.63281 9.33346 3.63281 9.33353 3.63281C9.558 3.63288 9.75718 3.74327 9.87568 3.91115Z",
			stroke: "#979797"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5875_132952",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "currentColor",
			transform: "translate(0 0.214844)"
		})
	}) })]
});
export default SvgIconTagEmpty;
